"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.useThemeRouter = exports.RouterContext = exports.withTheme = exports.buildTheme = exports.useTheme = exports.RouterTypes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const merge_1 = __importDefault(require("lodash/merge"));
const react_jss_1 = require("react-jss");
const globalLightTheme_1 = require("../themes/globalLightTheme/globalLightTheme");
const ResolveThemeVariables_1 = require("./ResolveThemeVariables");
const Utils_1 = require("./Utils");
const JssProvider_1 = require("./JssProvider");
var RouterTypes;
(function (RouterTypes) {
    RouterTypes["REACT_ROUTER"] = "reactRouter";
    RouterTypes["NEXT_ROUTER"] = "nextRouter";
})(RouterTypes || (exports.RouterTypes = RouterTypes = {}));
/**
 * Context hook for accessing the current theme set in ThemeProvider
 */
exports.useTheme = react_jss_1.useTheme;
/**
 * @param theme instance of GlobalThemeInterface that is going to be constructed
 * Construction mainly looks for other theme variable references via '$' and returns the value of the variable
 */
const buildTheme = (theme) => {
    const traverse = (obj) => {
        Object.keys(obj).forEach(key => {
            if ((0, ResolveThemeVariables_1.looksLikeThemeVariable)(obj[key]))
                obj[key] = (0, ResolveThemeVariables_1.resolveThemeVariable)(theme, obj[key]);
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                traverse(obj[key]);
            }
        });
    };
    // iterate over variants and construct theme by replacing variable usage
    Object.keys(theme).forEach(key => {
        // @ts-ignore
        traverse(theme[key]);
    });
    return theme;
};
exports.buildTheme = buildTheme;
/**
 * @param component - ReactNode to wrap theme provider around
 * @param theme - Theme provided which could be a custom extended theme from a global theme or a global theme itself.
 */
const withTheme = (component, theme, themeId) => {
    const builtTheme = (0, exports.buildTheme)(theme);
    return ((0, jsx_runtime_1.jsx)(exports.ThemeProvider, { theme: builtTheme, themeId: themeId !== null && themeId !== void 0 ? themeId : (0, react_1.useMemo)(() => (0, Utils_1.generateUUID)(), []), children: component }));
};
exports.withTheme = withTheme;
/**
 * ThemeProvider should be set as high as possible in the application
 * Leveraging the ThemeProvider will give you a hook into the global theme set and any
 * component leverages this theme.
 *
 * @param theme - theme to be set
 * @param children - child node (ReactNode)
 * @constructor
 */
exports.RouterContext = (0, react_1.createContext)({
    router: RouterTypes.REACT_ROUTER,
});
const useThemeRouter = () => (0, react_1.useContext)(exports.RouterContext);
exports.useThemeRouter = useThemeRouter;
const ThemeProvider = ({ children, cssReset = false, router = RouterTypes.REACT_ROUTER, theme = globalLightTheme_1.globalLightTheme, themeId = (0, react_1.useMemo)(() => (0, Utils_1.generateUUID)(), []), }) => {
    const value = (0, react_1.useMemo)(() => ({
        router,
    }), []);
    const builtTheme = (0, exports.buildTheme)((0, merge_1.default)({}, theme));
    if (cssReset)
        (0, Utils_1.useCssReset)();
    (0, Utils_1.setGlobalFonts)();
    return ((0, jsx_runtime_1.jsx)(JssProvider_1.JssProvider, { generateId: (rule, sheet) => (0, JssProvider_1.generateStandardId)(rule, sheet, themeId), children: (0, jsx_runtime_1.jsx)(exports.RouterContext.Provider, { value: value, children: (0, jsx_runtime_1.jsx)(react_jss_1.ThemeProvider, { theme: builtTheme, children: children }) }) }));
};
exports.ThemeProvider = ThemeProvider;
